import { render, staticRenderFns } from "./ListProducts.vue?vue&type=template&id=57ba2020&scoped=true"
import script from "./ListProducts.vue?vue&type=script&lang=js"
export * from "./ListProducts.vue?vue&type=script&lang=js"
import style0 from "./ListProducts.vue?vue&type=style&index=0&id=57ba2020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba2020",
  null
  
)

export default component.exports